import { useState } from 'react';
import api from '../services/api';

/**
 * @module useUpdateWeeklyAiReport
 * @description Custom hook for updating weekly AI reports in the Mental Health Portal application.
 * Manages updating state, error handling, and provides a function for updating weekly AI reports with optional resource recommendations.
 *
 * @requires react
 * @requires ../services/api
 */

/**
 * Hook to update weekly AI reports
 * @function useUpdateWeeklyAiReport
 * @returns {Object} Object containing updateWeeklyAiReport function, isUpdating state, and error state
 */

export const useBulkUpdateWeeklyAiReports = () => {
  const [isBulkUpdating, setIsBulkUpdating] = useState(false);
  const [error, setError] = useState(null);

  const updateWeeklyAiReports = async (reports) => {
    setIsBulkUpdating(true);
    setError(null);

    try {
      const payload = {
        reports: reports.map(({ id, aiResponse, resource }) => ({
          id,
          newAiReport: aiResponse,
          ...(resource?.id !== undefined && { resourceId: resource.id }), // only include if defined
        })),
      };

      const { data } = await api.post('update-weekly-ai-reports', payload);
      return data;
    } catch (err) {
      console.error('Erro ao atualizar múltiplos relatórios:', err);
      setError('Erro ao atualizar relatórios semanais');
      throw err;
    } finally {
      setIsBulkUpdating(false);
    }
  };

  return { updateWeeklyAiReports, isBulkUpdating, error };
};
